<section id="specialWizardModalContent" tabindex="-1" class='modal-content primary-bg-color primary-text-color'>
  <div class='modal-header secondary-bg-color secondary-text-color'>
    <button class='close float-right' (click)='handleCancel()' [attr.aria-label]="'component.special_wizard_modal_content.close' | translate" id="cancelButton">
      <span aria-hidden='true'>&times;</span>
    </button>
    <h2 id="modal-title" class='modal-title float-left'>{{specialWizard.orderableSpecial?.label}}</h2>
  </div>
  <div #modalBody class='modal-body transparent'>
    <div class='wrapper text-left'>
      <aside class='steps primary-bg-color' *ngIf="!(breakPointService.isXSMobile$ | async)">
        <button class="btn step-btn font-secondary" *ngFor="let step of specialWizard.steps"
                ftsAuditableButton auditName="Step{{step.stepIndex+1}} {{step.title}}"
                [ngClass]="{'selection-bg-color selection-inverse-text-color': step.stepIndex === specialWizard.currentStepIndex,
              'primary-text-color': step.stepIndex !== specialWizard.currentStepIndex}"
                (click)="onStepClick(step)">
          <div class='step-info' [attr.data-flash]="step.stepIndex === specialWizard.currentStepIndex ? true : undefined">
            <h3 class="h5">Step {{step.stepIndex + 1}} <span *ngIf='step.isFulfilled' class='step-fulfilled-check-mark'>&#10003;</span></h3>
            <p *ngIf="step.selectedOrderedItem">
            <span *ngIf="step.selectedOrderedItem?.size !== 'Size'">
              {{step.selectedOrderedItemSizeLabel}}
            </span>
              <span>{{step.selectedOrderableItem?.label}}<sup
                *ngIf="step.selectedOrderableItem?.labelSymbol">{{step.selectedOrderableItem.labelSymbol}}</sup></span>
            </p>
            <p *ngIf="!step.selectedOrderedItem">
              {{step.title}}
            </p>
          </div>
        </button>
      </aside>
      <section class='body' #scrollWrapper>
        <ng-container *ngIf="(breakPointService.isXSMobile$ | async)">
          <div class="mobile-steps"
                *ngIf="!specialWizard.currentStep?.selectedOrderedItem ||
                orderedItemService.getFilteredIngredientChoices(specialWizard.currentStep?.selectedOrderableItem, specialWizard.currentStep?.selectedOrderedItem).length === 0">
            <ng-container *ngFor="let step of specialWizard.steps">
              <button *ngIf="step.stepIndex <= specialWizard.currentStepIndex"
                      class="btn step-btn primary-text-color primary-bg-color font-secondary"
                      (click)="onStepClick(step)">
                <div class='step-info'>
                  <h3 class="h5">Step {{step.stepIndex + 1}} <span *ngIf='step.isFulfilled' class='step-fulfilled-check-mark selection-text-color'>&#10003;</span></h3>
                  <p *ngIf="step.selectedOrderedItem">
                  <span *ngIf="step.selectedOrderedItem?.size !== 'Size'">
                    {{step.selectedOrderedItemSizeLabel}}
                  </span>
                    <span>{{step.selectedOrderableItem?.label}}</span>
                  </p>
                  <p *ngIf="!step.selectedOrderedItem">
                    <span class="fw-600">&#8595;</span> {{step.title}}
                  </p>
                </div>
              </button>
            </ng-container>
          </div>
        </ng-container>

        <div class="inner-body" *ngIf="specialWizard.steps && specialWizard.steps.length > 0 && !!specialWizardBodySet" id="item-editor-body">
          <div class="sr-only" tabindex="0">Step{{specialWizard.currentStep.stepIndex+1}} {{specialWizard.currentStep.title}}</div>
          <ng-container *ngIf="!specialAdditionFailedMode">
            <fts-special-wizard-item-editor
              *ngIf="!specialWizard.currentStep?.shouldForceItemSelection && (specialWizard.currentStep?.selectedOrderedItem &&
                orderedItemService.getFilteredIngredientChoices(specialWizard.currentStep?.selectedOrderableItem, specialWizard.currentStep?.selectedOrderedItem).length > 0)"
              [currentStep]="specialWizard.currentStep"></fts-special-wizard-item-editor>

            <fts-special-wizard-item-selector
              *ngIf="specialWizard.currentStep?.shouldForceItemSelection || (!specialWizard.currentStep?.selectedOrderedItem ||
              orderedItemService.getFilteredIngredientChoices(specialWizard.currentStep?.selectedOrderableItem, specialWizard.currentStep?.selectedOrderedItem).length === 0)"
              [currentStep]="specialWizard.currentStep" (itemSelected)="onItemSelected($event)"></fts-special-wizard-item-selector>
          </ng-container>

          <ng-container *ngIf="specialAdditionFailedMode">
            <h4>{{'component.special_wizard_modal_content.read_instructions' | translate}}</h4>
            <div *ngIf="specialWizard.orderableSpecial?.instructions">
              <h3 class="font-secondary">{{'component.special_wizard_modal_content.instructions' | translate}}</h3>
              <hr class="no-top-margin" aria-hidden="true">
              <p class="lead">{{specialWizard.orderableSpecial?.instructions}}</p>
            </div>
            <div *ngIf="specialWizard.orderableSpecial?.disclaimer">
              <h3 class="font-secondary">{{'component.special_wizard_modal_content.disclaimer' | translate}}</h3>
              <hr class="no-top-margin" aria-hidden="true">
              <p class="lead">{{specialWizard.orderableSpecial?.disclaimer}}</p>
            </div>
          </ng-container>

        </div>
      </section>
    </div>
  </div>
  <fts-special-wizard-modal-footer
    [shouldForceAddToOrder]="shouldForceAddToOrder"
    [specialAdditionFailedMode]="specialAdditionFailedMode"
    [orderableItem]="specialWizard.currentStep?.selectedOrderableItem"
    [orderedItem]="specialWizard.currentStep?.selectedOrderedItem"
    [stepOrdinal]="specialWizard.currentStep?.stepIndex"
    [isLastStep]="specialWizard.isLastStepSelected"
    [addingSpecialToOrder]="addingSpecialToOrder"
    (cancelClick)="handleCancel()"
    (nextStepClick)="goToNextStep()"
    (addToOrderClick)="addSpecialToOrder()"
    (resetSpecialAdditionFailedMode)="resetSpecialAdditionFailedMode()"
  ></fts-special-wizard-modal-footer>
</section>

